const COARSE_TOUCH_QUERY = "(hover: none) and (pointer: coarse)"

function isCoarseTouchDevice() {
  return window.matchMedia(COARSE_TOUCH_QUERY).matches
}

function showRevealsImmediately(root = document) {
  root.querySelectorAll(".reveal:not(.is-visible)").forEach((el) => {
    el.classList.add("is-visible")
  })
}

function observeReveals(root = document) {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    showRevealsImmediately(root)
    return
  }

  const reveals = [...root.querySelectorAll(".reveal:not(.is-visible)")]
  if (!reveals.length) return

  const skipAnimatedReveal = (el) => isCoarseTouchDevice() && el.closest("#work")

  reveals.forEach((el) => {
    if (skipAnimatedReveal(el)) el.classList.add("is-visible")
  })

  const animatedReveals = reveals.filter((el) => !skipAnimatedReveal(el))
  if (!animatedReveals.length) return

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible")
          observer.unobserve(entry.target)
        }
      })
    },
    { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
  )

  animatedReveals.forEach((el) => observer.observe(el))
}

function initLandingAnimations() {
  observeReveals()
}

document.addEventListener("DOMContentLoaded", initLandingAnimations)